/**
 * QCCT 2026 — định mức công tác phí (mock).
 * Sync với BusinessTravelSection (tab Cài đặt · Công tác).
 * Áp dụng cho auto-compute dự toán trong form Tạm ứng · Công tác.
 */

export type QcctNhom = 1 | 2 | 3 | 4;
export type QcctVung = 'HN_HCM' | 'TinhI' | 'TinhKhac' | 'Foreign';

export const NHOM_LABEL: Record<QcctNhom, string> = {
  1: 'Nhóm 1 · BGĐ, Chủ tịch HĐQT',
  2: 'Nhóm 2 · KTT, GĐ khối, GĐ dự án lớn',
  3: 'Nhóm 3 · Trưởng phòng, Team Lead, Senior',
  4: 'Nhóm 4 · Chuyên viên, NV, Junior, TTS',
};

export const VUNG_LABEL: Record<QcctVung, string> = {
  HN_HCM: 'Hà Nội · TP.HCM',
  TinhI: 'Tỉnh loại I (Đà Nẵng, Hải Phòng, Cần Thơ…)',
  TinhKhac: 'Tỉnh khác + huyện thị',
  Foreign: 'Nước ngoài',
};

/** Tiền ở · đồng/đêm — nhóm × vùng. Foreign = 2× HCM (theo QCCT-quốc tế 2026). */
const LODGING: Record<QcctNhom, Record<QcctVung, number>> = {
  1: { HN_HCM: 4_000_000, TinhI: 3_000_000, TinhKhac: 2_500_000, Foreign: 8_000_000 },
  2: { HN_HCM: 3_000_000, TinhI: 2_500_000, TinhKhac: 2_000_000, Foreign: 6_000_000 },
  3: { HN_HCM: 2_200_000, TinhI: 1_800_000, TinhKhac: 1_500_000, Foreign: 4_400_000 },
  4: { HN_HCM: 1_500_000, TinhI: 1_200_000, TinhKhac: 1_000_000, Foreign: 3_000_000 },
};

/** Phụ cấp lưu trú · đồng/ngày — theo nhóm. */
const PER_DIEM: Record<QcctNhom, number> = {
  1: 600_000,
  2: 500_000,
  3: 400_000,
  4: 300_000,
};

/** Đi lại (khoán trung bình, gồm 2 chiều) · đồng/chuyến — theo vùng. */
const TRAVEL_ONE_TRIP: Record<QcctVung, number> = {
  HN_HCM: 3_500_000,   // vé máy bay khứ hồi + taxi
  TinhI: 2_500_000,
  TinhKhac: 1_500_000,
  Foreign: 15_000_000,
};

export interface QcctBudget {
  lodging: number;      // Tiền ở
  perDiem: number;      // Phụ cấp lưu trú
  travel: number;       // Đi lại
  contingency: number;  // Dự phòng 10%
  total: number;        // Tổng dự toán tối đa
}

export function computeQcctBudget(nhom: QcctNhom, vung: QcctVung, days: number): QcctBudget {
  const d = Math.max(1, Math.floor(days || 0));
  const lodging = LODGING[nhom][vung] * Math.max(0, d - 1); // n đêm = (n ngày − 1) đêm
  const perDiem = PER_DIEM[nhom] * d;
  const travel = TRAVEL_ONE_TRIP[vung];
  const subtotal = lodging + perDiem + travel;
  const contingency = Math.round((subtotal * 0.1) / 1000) * 1000;
  const total = subtotal + contingency;
  return { lodging, perDiem, travel, contingency, total };
}
